import { render } from "./AssetsUpload.vue?vue&type=template&id=27e8e625"
import script from "./AssetsUpload.vue?vue&type=script&lang=js"
export * from "./AssetsUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__